const imageChanger = (function ($, getCookie, locationService) {

    var initialized = false;

    function changeBackgroundImage(loc) {
        $('.front-overlay').fadeIn();
        var url = '/@image',
            params = {
                kommune: loc.kommune,
                fylke: loc.fylke
            };
        $.get(
            url,
            params,
            function (response) {
                if (response.image) {
                    var image = new Image();
                    image.onload = function () {
                        $('#frontBanner').css('background', 'url(' + image.src + ') no-repeat');
                        $('.front-overlay').fadeOut();
                    };
                    image.onerror = function () {
                        $('.front-overlay').fadeOut();
                    };
                    image.src = response.image;

                    setCookie('image', response.image);

                } else {
                    $('.front-overlay').fadeOut();
                }
            }
        );
    }

    function init() {
        if (initialized === true) {
            return;
        }
        $('.is-search-input.kommune_select').on('change.image-background', function () {
            var kom = slugify($(this).val());
            var fyl = $(this).find('option:selected').data('for') || '';

            changeBackgroundImage(
                {
                    kommune: kom,
                    fylke: fyl
                }
            );
        });

        $('.is-search-input.fylke_select').on('change.image-background', function () {
            var fyl = slugify($(this).val());

            changeBackgroundImage(
                {
                    kommune: '',
                    fylke: fyl
                }
            );
        });

        initialized = true;
    }

    return {
        init: init,
        _initChangeImage: function (force) {
            init();
            if (!getCookie('image') || !!force === true) {
                changeBackgroundImage(
                    {
                        kommune: locationService.get('kommune'),
                        fylke: locationService.get('fylke')
                    }
                );
            }
        }
    };
}(jQuery, getCookie, locationService));

_initChangeImage();


function _initChangeImage(force) {
    imageChanger._initChangeImage(force);
}
